import React from "react";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button)(({ theme }) => ({
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

function PouchErrorModal({ hideModal, kind }) {
  return (
    <>
      <DialogTitle id={`${kind}-modal-title`}>Hinweis</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <p>
            Materialien und Annotationen können nicht geladen werden. Das könnte daran liegen, dass sie im{" "}
            <b>privaten Modus</b> browsen.
          </p>
          <br />
          <p>
            Eine detaillierte Anleitung zur Behebung dieses Problems findet sich{" "}
            <a href="https://login.mildenberger-digital.de/hilfe/" target="_blank" rel="noopener noreferrer">
              auf unserer Hilfeseite
            </a>{" "}
            unter dem Punkt &apos;Im Firefox-Browser werden keine Materialien angezeigt&apos;
          </p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <StyledButton color="primary" variant="text" onClick={() => hideModal()}>
          Schließen
        </StyledButton>
      </DialogActions>
    </>
  );
}

PouchErrorModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  kind: PropTypes.string.isRequired
};

export default PouchErrorModal;
